import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import Env from "./util/env"
import "./index.css"

const domId = "rootAI"
Env.setReferrer()
ReactDOM.render(<App />, document.getElementById(domId))
